import { render } from "./SalesFlatRatesTable.vue?vue&type=template&id=c97c4130&scoped=true"
import script from "./SalesFlatRatesTable.vue?vue&type=script&lang=js"
export * from "./SalesFlatRatesTable.vue?vue&type=script&lang=js"

import "@/assets/scss/components/sales/_sales-flat-rates-table.scss?vue&type=style&index=0&id=c97c4130&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97c4130"]])

export default __exports__